import React from "react";
import { Dialog, DialogContent, DialogActions, Typography } from "@mui/material";
import Controls from "../controls/Controls";

export default function OrderAssignConfirmDialog(props) {
  const { confirmDialog, setConfirmDialog } = props;

  return (
    <Dialog
      open={confirmDialog.isOpen}
      sx={{
        "& .MuiDialog-paper": {
          padding: (theme) => theme.spacing(2),
          position: "absolute",
          top: (theme) => theme.spacing(5),
        },
      }}
    >
      <DialogContent
        sx={{
          textAlign: "center",
        }}
      >
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "end",
        }}
      >
        <Controls.Button
          text="Cancel"
          color="inherit" 
          onClick={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}
        />
      </DialogActions>
    </Dialog>
  );
}